import { createContext, useContext, useEffect, useState } from "react";
import {
  api,
  clearActiveClinicId,
  formatApiError,
  getActiveClinicId,
  setActiveClinicId,
} from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=logged in
  const [error, setError] = useState("");

  async function loadCurrentUser() {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      if (e?.response?.status === 403 && getActiveClinicId()) {
        clearActiveClinicId();
        try {
          const res = await api.get("/auth/me");
          setUser(res.data);
          return;
        } catch {
          // Fall through to the signed-out state below.
        }
      }
      setUser(false);
    }
  }

  useEffect(() => {
    loadCurrentUser();
  }, []);

  async function login(email, password) {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setActiveClinicId(data.clinic_id);
      setUser(data);
      return { ok: true };
    } catch (e) {
      const msg = formatApiError(e);
      setError(msg);
      return { ok: false, error: msg };
    }
  }

  async function logout() {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    clearActiveClinicId();
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
